import React, { useState, useEffect } from 'react';
import { firebaseService } from '../services/firebaseService';
import '../styles/components.css';

const PromptInput = ({ onSubmit, isActive, placeholder = "Enter your prompt...", submitLabel }) => {
    const [prompt, setPrompt] = useState('');
    const [wordCount, setWordCount] = useState(0);
    const [isGenerating, setIsGenerating] = useState(false);
    const MAX_WORDS = 5;

    useEffect(() => {
        const words = prompt.trim().split(/\s+/).filter(word => word.length > 0);
        setWordCount(words.length);
    }, [prompt]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (prompt.trim() && isActive && wordCount <= MAX_WORDS) {
            try {
                await onSubmit(prompt.trim());
                setPrompt('');
            } catch (error) {
                console.error('Error submitting prompt:', error);
            }
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        const words = newValue.trim().split(/\s+/).filter(word => word.length > 0);
        if (words.length <= MAX_WORDS) {
            setPrompt(newValue);
        }
    };

    const handleRandomWords = async () => {
        try {
            setIsGenerating(true);
            // Call the server endpoint to get random words
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/random-words`);
            if (!response.ok) {
                throw new Error('Failed to get random words');
            }
            const { words } = await response.json();
            setPrompt(words.join(' '));
        } catch (error) {
            console.error('Failed to get random words:', error);
        } finally {
            setIsGenerating(false);
        }
    };

    return (
        <div className="prompt-input-wrapper">
            <form onSubmit={handleSubmit} className="prompt-input-container">
                <div className="prompt-input-group">
                    <button
                        type="button"
                        className="random-button"
                        onClick={handleRandomWords}
                        disabled={!isActive || isGenerating}
                    >
                        {isGenerating ? '🎲...' : '🎲'}
                    </button>
                    <input
                        type="text"
                        placeholder={placeholder}
                        value={prompt}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyPress}
                        className="prompt-input"
                        disabled={!isActive || isGenerating}
                    />
                </div>
                <button
                    type="submit"
                    className="primary-button"
                    disabled={!prompt.trim() || !isActive || wordCount > MAX_WORDS || isGenerating}
                >
                    {submitLabel || (placeholder.includes("guess") ? "Submit 👉" : "✨ Create")}
                </button>
            </form>
            {/* <div className={`word-count ${wordCount > MAX_WORDS ? 'error' : ''}`}>
                {wordCount}/{MAX_WORDS} words
            </div> */}
        </div>
    );
};

export default PromptInput; 